import {createContext, useContext} from 'react';
import type {ProactFormApi} from './useProactForm';

export const ProactFormContext = createContext<ProactFormApi | undefined>(
  undefined
);

export function useProactFormContext(): ProactFormApi {
  const context = useContext(ProactFormContext);
  if (!context) {
    throw new Error(
      'useProactFormContext must be used within a <ProactForm> provider'
    );
  }
  return context;
}
